import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'; 
import { DialogActionsEnum, DialogComponent, DialogConfigInterface } from 'appShared/components/dialog';
import { CreatePlanForm } from 'appEntries/panel/forms';
import { ApiError, ApiResponse, HttpStatusCodesEnum, LookupInterface, ServerResponseData, TradingPlanResponseInterface, TradingPlanService } from '@spa/api';
import { TradingPlanFormErrorStatesEnum } from 'appEntries/panel/enums';
import { PlanAddMessages } from 'appAssets/messages';
import { AlertTypesEnum, PermissionRuleCheckStrategiesEnum } from 'appShared/enums';
import { AlertsService } from 'appShared/services';
import { PermissionRulesTrait } from 'appEntries/panel/traits';
import { FormInterface, PermissionRuleInterface } from 'appShared/interfaces';
import { Subscription } from 'rxjs';
import { FormComponent } from 'appShared/widgets';
import { PanelPaths } from 'appShared/paths';
import { Router } from '@angular/router';

@Component({
  selector: 'app-plan-add',
  templateUrl: './plan-add.component.html',
  styleUrls: ['./plan-add.component.scss']
})
export class PlanAddComponent extends DialogComponent<PlanAddComponent> implements FormInterface, OnDestroy, OnInit {

  protected subscriptions: Subscription[];
  public permissionRule: PermissionRuleInterface;
  public availablePlanTypes: LookupInterface;
  public form: CreatePlanForm; 
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      config: DialogConfigInterface,
      availablePlanTypes: LookupInterface,
    }, 
    protected router: Router, 
    protected alertsService: AlertsService,
    protected tradingPlanService: TradingPlanService,

    public dialogRef: MatDialogRef<PlanAddComponent>,
  ) {
    super(dialogRef);
    this.subscriptions = [];
    this.permissionRule = PermissionRulesTrait.getMarketDataFeedManagementPermissionRule(PermissionRuleCheckStrategiesEnum.Union);
    this.config = data.config;
    this.availablePlanTypes = data.availablePlanTypes;
  }
  handleErrorResponse(response: ApiResponse<ApiError[] | TradingPlanResponseInterface>, error: ApiError): string {
    if (Array.isArray(response.messages) && response.messages[0]) {
      return response.messages[0];
    }

    return this.getErrorMessageByApiError(error);
  }

  onFormSubmit(action?: number): void {
    if (action !== DialogActionsEnum.Confirm) {
      this.dialogRef.close(false);

      return;
    }

    if (this.validateForm()) {
      const requestSubscription = this.form.createRequest()
        .subscribe((response: ServerResponseData<TradingPlanResponseInterface>) => {
          if (response.status !== HttpStatusCodesEnum.Ok) {
            (response.data as ApiError[]).map((error: ApiError) => this.handleErrorResponse(response, error))
              .filter((errorMessage: string) => {
                return errorMessage.trim();
              }).forEach((errorMessage: string) => {
                this.alertsService.addAlert(errorMessage);
              });

            return;
          } 
          const data = response.data as TradingPlanResponseInterface;
          this.alertsService.addAlert(this.getSuccessFormMessage(), AlertTypesEnum.Success);
          const path = [
            PanelPaths.root,
            PanelPaths.children.plans.path,
            PanelPaths.children.plans.children.edit.path,
            data.id
          ].join('/');
           

          this.router.navigate([path])
            .finally();

          this.dialogRef.close(true);
        });
      this.subscriptions.push(requestSubscription);
    }
  }

  getFormMessages(controlLabel?: string): { [p: string]: string } {
    return FormComponent.getFormMessages(controlLabel);
  }

  validateForm(): boolean {
    return this.form.validateForm(this.getFormMessages);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription && subscription.unsubscribe());
  }

  ngOnInit(): void {
    this.initForm();
  }   

  initForm(): void {
    this.form = new CreatePlanForm(this.tradingPlanService, this.availablePlanTypes);
    this.form.initForm();
  }

  getSuccessFormMessage(): string {
    return PlanAddMessages.PlanCreationSucceed.message;
  }

  getErrorMessageByApiError(error: ApiError): string {
    if (error.status === TradingPlanFormErrorStatesEnum.CreatePlanFailed) {
      return PlanAddMessages.PlanCreationFailed.message;
    }

    return PlanAddMessages.UnknownError.message;
  }
}
